
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { Location } from "vue-router";
import { LOGO_URL } from "@/lib/urlHelpers";

interface Props {
  href?: string;
  to?: Location;
  imgClass?: string;
  small?: boolean;
}

export default Vue.extend({
  functional: true,
  name: "SiteLogo",
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const { href, to, imgClass, small = true } = ctx.props;
    const classes = [...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), ctx.data.staticClass];
    const imgLogo = h("img", {
      staticClass: "logo",
      class: [...(!href && !to ? classes : []), imgClass, { __small: small }],
      attrs: {
        src: LOGO_URL,
        alt: "logo",
      },
    });
    if (href) return h("a", { class: classes, attrs: { href } }, [imgLogo]);
    if (to) return h("router-link", { class: classes, props: { to } }, [imgLogo]);
    return imgLogo;
  },
});
